import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faCloudDownloadAlt} from '@fortawesome/pro-solid-svg-icons';
import {canManageCurrentCartArchive} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Unarchive cart assets
 * @param params
 * @returns Action
 */
export const cartActionManageArchiveUnarchive = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'current-cart-manage-archive-unarchive',
	get label() {
		return CART_CURRENT_ACTION_LABELS.MANAGE_ARCHIVE_UNARCHIVE;
	},
	icon: faCloudDownloadAlt,
	enableTest: canManageCurrentCartArchive,
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.MANAGE_ARCHIVE_UNARCHIVE),
	...params,
});

export default cartActionManageArchiveUnarchive;
